import { Box, Button } from '@mui/material';
import { DataGrid, GridAddIcon, type GridColDef } from '@mui/x-data-grid';
import { Link, NavLink, Outlet } from 'react-router';

import PageBaseLayout from '../layouts/PageBaseLayout';
import { useEffect, useState } from 'react';
import { supabase } from '../supabase-client';
import type { Merchant } from '../models/types';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';

export default function Merchants() {
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();
  const [merchants, setMerchants] = useState<Merchant[]>([
    {
      id: 1,
      name: 'Logitech',
      email: '',
      category_id: 1,
      category: 'F&B',
      subcategory_id: 4,
      subcategory: 'Coffee',
      caption: 'Mice',
      logoUrl: 'https://123.com',
      priority: 1,
    },
  ]);
  const columns: GridColDef<Merchant>[] = [
    {
      field: 'name',
      headerName: 'Brand',
      type: 'string',
      width: 160,
      renderCell: (param) => (
        <Button
          fullWidth
          component={NavLink}
          to={`./${param.row.id}`}
          state={param.row}
          size="small"
          variant="outlined"
          sx={{ justifyContent: 'flex-start', textAlign: 'left' }}>
          {param.value}
        </Button>
      ),
    },
    {
      field: 'balance',
      headerName: 'Balance',
      width: 85,
      type: 'number',
      renderCell: (param) => (
        <Button
          {...(param.value < 0 && {
            sx: {
              backgroundColor: 'red',
            },
          })}
          fullWidth
          component={NavLink}
          to={`../tranding-merchant-transactions/${param.row.id}`}
          state={param.row.id}
          size="small"
          variant="outlined">
          {param.value}
        </Button>
      ),
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
      type: 'string',
      renderCell: (param) => (
        <a href={`mailto:${param.value}`}>{param.value}</a>
      ),
    },
    {
      field: 'category',
      headerName: 'Category',
      width: 150,
    },
    {
      field: 'subcategory',
      headerName: 'Subcategory',
      width: 150,
    },
    {
      field: 'caption',
      headerName: 'Caption',
      width: 240,
      type: 'string',
    },
    {
      field: 'logo_url',
      headerName: 'Logo',
      width: 240,
      type: 'string',
      renderCell: (param) => (
        <Box display="flex" alignItems="center" height="100%">
          <img src={param.value} height={40} />
        </Box>
      ),
    },
  ];

  const getData = async () => {
    backdrop.handleBackdropOpen();

    try {
      const { data, error } = await supabase
        .schema('admin_backend')
        .from('merchants_admin_view')
        .select('*, brand_balances(*)');

      if (error) {
        console.error('Error fetching brands:', error);
        throw error;
      }

      setMerchants(
        data.map((brand) => ({
          ...brand,
          balance: brand.brand_balances.balance,
        })),
      );
    } catch (error) {
      const errorCast = error as Error;
      console.error(errorCast.stack);
      snackbar.handleSnackbarOpen(errorCast.message, 'error');
    }

    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PageBaseLayout
      title="Brands"
      actions={
        <Button
          component={Link}
          to="./new"
          startIcon={<GridAddIcon />}
          size="small"
          variant="contained">
          New Brand
        </Button>
      }>
      <DataGrid columns={columns} rows={merchants} />
      <Outlet />
    </PageBaseLayout>
  );
}
